/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Status_Loading_CommitInputs */

const en_team_project_import_status_loading_commit = /** @type {(inputs: Team_Project_Import_Status_Loading_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading commit...`)
};

const fr_team_project_import_status_loading_commit = /** @type {(inputs: Team_Project_Import_Status_Loading_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement du commit...`)
};

const de_team_project_import_status_loading_commit = /** @type {(inputs: Team_Project_Import_Status_Loading_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit wird geladen...`)
};

const it_team_project_import_status_loading_commit = /** @type {(inputs: Team_Project_Import_Status_Loading_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento commit in corso...`)
};

const ru_team_project_import_status_loading_commit = /** @type {(inputs: Team_Project_Import_Status_Loading_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка коммита...`)
};

const es_team_project_import_status_loading_commit = /** @type {(inputs: Team_Project_Import_Status_Loading_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando confirmación...`)
};

const zh_cn2_team_project_import_status_loading_commit = /** @type {(inputs: Team_Project_Import_Status_Loading_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载提交...`)
};

const ja_team_project_import_status_loading_commit = /** @type {(inputs: Team_Project_Import_Status_Loading_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミットを読み込んでいます...`)
};

const hi_team_project_import_status_loading_commit = /** @type {(inputs: Team_Project_Import_Status_Loading_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कमिट लोड हो रहा है...`)
};

const pt_pt2_team_project_import_status_loading_commit = /** @type {(inputs: Team_Project_Import_Status_Loading_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando commit...`)
};

/**
* | output |
* | --- |
* | "Loading commit..." |
*
* @param {Team_Project_Import_Status_Loading_CommitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_status_loading_commit = /** @type {((inputs?: Team_Project_Import_Status_Loading_CommitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Status_Loading_CommitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_status_loading_commit(inputs)
	if (locale === "de") return de_team_project_import_status_loading_commit(inputs)
	if (locale === "it") return it_team_project_import_status_loading_commit(inputs)
	if (locale === "ru") return ru_team_project_import_status_loading_commit(inputs)
	if (locale === "es") return es_team_project_import_status_loading_commit(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_status_loading_commit(inputs)
	if (locale === "ja") return ja_team_project_import_status_loading_commit(inputs)
	if (locale === "hi") return hi_team_project_import_status_loading_commit(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_status_loading_commit(inputs)
	return en_team_project_import_status_loading_commit(inputs)
});